
function install(Vue, { Translator, useFallBackDicitionary }) {
    Translator.setUseFallbackDictionary(useFallBackDicitionary);
    Object.defineProperty(Vue.prototype, '$translator', {
        get () {
            return Translator;
        },
    });

    // can use {{ shlomo | i18n }} in order to translate.
    Vue.filter('i18n', function (value) {
        return Translator.translate(value);
    });
}

export default {
    install,
};
